import styles from "components/Form/Form.module.scss";

export const formConfig = {
  category: {
    title: "Category",
    elementType: "select",
    elementConfig: {
      id: "category",
      value: "",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: true,
    },
    options: [
      { value: "", text: "--select-category--" },
      { value: "ivr-menu", text: "IVR Menu" },
      { value: "ivr-welcome", text: "IVR Welcome" },
      { value: "callcenter", text: "Call Center" }
    ],
    valid: false,
    touched: false,
    error: { message: "Category is required" },
  },
  file: {
    title: "Upload File",
    elementType: "file",
    elementConfig: {
      id: "file",
      type: "file",
      accept: ".wav",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.file,],
    validation: {
      required: true,
    },
    valid: false,
    touched: false,
    error: { message: "An audio file is required" },
  },
};
